import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import store from "../Common/Store";
import { useTranslation, Trans } from "react-i18next";
import LangSelect from "../Common/LangSelect";

function Home() {
  const { i18n, t } = useTranslation();

  useEffect(() => {
    store.empty();
    i18n.changeLanguage(localStorage.getItem("lang"));
  }, [i18n]);

  return (
    <main
      className="home-page"
      style={{ backgroundImage: 'url("img/start_img.png")' }}
    >
      <div className="home-page__shade" />

      <section className="home-card" aria-labelledby="home-heading">
        <div className="home-card__content">
          <img className="home-card__logo" src="img/logo_main.png" alt="Heat Mat" />
          <span className="home-card__divider" aria-hidden="true" />
          <h1 id="home-heading" className="home-card__heading">
            {t("home_title_line_1")}
            <br />
            {t("home_title_line_2")}
          </h1>
          <p className="home-card__intro">
            {t("home_intro")}
          </p>
          <Link to="/mode" className="home-card__start-link">
            <button className="start_btn" type="button">
              <Trans i18nKey="Start" />
            </button>
          </Link>
        </div>
      </section>

      <LangSelect func={i18n.changeLanguage} />
    </main>
  );
}

export default Home;
